import { initializeMediaSyncronization, onClickTogglePlayMedia, loadAndPlay } from './synchronizeMedia';
import { syncronizeServerTime } from './syncronizeServerTime';
// import { playWebAudio, initializeWebAudioSyncronization } from './synchronizeWebAudio.js';
import { logger } from '@/tools';
export { unSync } from './synchronizeMedia';

/* eslint-disable no-unused-vars */

let $progress;
let serverTimeSyncUrl;
let srcUrl = '';
let mediaType = null;
let startTime = null;

function isChromiumBased() {
	return (function (agent) {
		switch (true) {
			case agent.indexOf('edge') > -1:
				return false; // "MS Edge (EdgeHtml)";
			case agent.indexOf('edg') > -1:
				return true; // "MS Edge Chromium";
			case agent.indexOf('opr') > -1 && !!window.opr:
				return true; // "opera";
			case agent.indexOf('chrome') > -1 && !!window.chrome:
				return true; // "chrome";
			case agent.indexOf('trident') > -1:
				return false; // "Internet Explorer";
			case agent.indexOf('firefox') > -1:
				return false; // "firefox";
			case agent.indexOf('safari') > -1:
				return false; // "safari";
			default:
				return false; // "other";
		}
	})(navigator.userAgent.toLowerCase());
}

function isAppleBased() {
	const macRegex = /(ipad)|(iphone)|(ipod)|(mac)/i;
	return macRegex.test(navigator.platform);
}

const isChromium = isChromiumBased();
const isApple = isAppleBased();
function isWebAudio() {
	return mediaType === 'audio' && isChromium && !isApple;
}

function setProgress(percent) {
	if ($progress) $progress.style.width = `${percent}%`;
}

export async function onClickTogglePlay() {
	// if (!isWebAudio())
	onClickTogglePlayMedia();
	let serverTimeOffset;
	try {
		serverTimeOffset = await syncronizeServerTime({ progressFunction: setProgress, serverTimeSyncUrl });
	} catch (error) {
		logger.error(error);
		return;
	}
	// if (isWebAudio()) playWebAudio({ serverTimeOffset, srcUrl, startTime });
	// else
	loadAndPlay({ _serverTimeOffset: serverTimeOffset, srcUrl });
}

export function initializeSyncronization(options) {
	({ $progress, mediaType, startTime } = options);
	srcUrl = options.src;
	const { startPlaying, dataSourceURL } = options;

	if (!startTime) throw new Error('audioTogglePlay: start time not defined.');

	// DOM element fallbacks, FIXME this is hacky we should make this nicer
	let { $el } = options;
	if (!$el) {
		$el = document.querySelector(`.ui--${mediaType}`);
		options.$el = $el;
	}
	if ($el) {
		$progress = $el.querySelector('.element__progress__bar');
	} else {
		$progress = null;
		setTimeout(() => {
			startTime;
			$el = document.querySelector(`.ui--${mediaType}`);
			if ($el) $progress = $el.querySelector('.element__progress__bar');
		}, 700);
		logger.warn(`the ${mediaType} player is not in the DOM yet, progress is missing`);
	}

	// If there is a datasource URL we will used a local time sync server
	const isWebRegEx = /(web.cms.shoutrlabs.com)|(web.staging.shoutrlabs.com)/;
	if (isWebRegEx.test(dataSourceURL)) {
		serverTimeSyncUrl = 'https://time.cms.shoutrlabs.com';
	} else if (dataSourceURL) {
		serverTimeSyncUrl = `${dataSourceURL}time.php`;
	}

	options.progressFunction = setProgress;

	if (!(options.mediaDuration || options.configStartTime)) {
		throw new Error('Please edit the article, duration or start time are missing.');
	}
	if (!(options.$media && options.mediaType)) {
		throw new Error('initMediaSyncElements was not called or without parameters');
	}

	// if (isWebAudio()) initializeWebAudioSyncronization(options);
	// else
	initializeMediaSyncronization(options);
	if (startPlaying) onClickTogglePlay();
}
